import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularMeterialModule } from './modules/angular-meterial/angular-meterial.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AgmCoreModule } from '@agm/core'; 

import { IdletimemodalComponent } from './components/idletimemodal/idletimemodal.component';
import { DefaultComponent } from '../layouts/default/default.component';
import { HeaderComponent } from '../core/header/header.component';
import { SideNavComponent } from '../core/side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { AppUserRoleDirective } from '../auth/directives/app-user-role.directive';
import { BreadcrumbComponent } from '../core/breadcrumb/breadcrumb.component';
import { TableLoaderComponent } from './components/loader/tableLoader.component';

import { NumberToStringConvert } from './pipes/numberToStringConvert.pipe';
import { TimeFormatPipe } from './pipes/timeFormat.pipe';
import { TableShowColumnsPipe } from './pipes/tableShowColumns.pipe';

import { ClockComponent } from './components/clock/clock.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
  declarations: [
    IdletimemodalComponent,
    DefaultComponent,
    HeaderComponent,
    SideNavComponent,
    BreadcrumbComponent,
    AppUserRoleDirective,
    NumberToStringConvert,
    TimeFormatPipe,
    TableShowColumnsPipe,
    ClockComponent,
    TableLoaderComponent,
    BarChartComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AngularMeterialModule,
    NgxMaterialTimepickerModule.setLocale('en-US'),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAxaIfB4PhyqLZ23kfZeZ9mTgLxPgEzczs'
    }), 
    NgMultiSelectDropDownModule.forRoot()
  ],
  exports: [
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AngularMeterialModule,
    IdletimemodalComponent,
    DefaultComponent,
    HeaderComponent,
    SideNavComponent,
    BreadcrumbComponent,
    AppUserRoleDirective,
    NgxMaterialTimepickerModule,
    NumberToStringConvert,
    TimeFormatPipe,
    TableShowColumnsPipe,
    ClockComponent,
    AgmCoreModule,
    TableLoaderComponent,
    BarChartComponent,
    NgMultiSelectDropDownModule
  ]
})
export class SharedModule { }
